import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../../services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { LearningPathService } from 'src/app/services/learning-path.service';
import { LearningPathFullModel } from 'src/app/models/learning-paths/learning-path.model';
import { forkJoin, shareReplay } from 'rxjs';
import { CoursePersonStatusModel } from 'src/app/models/learning-path/learning-path-course.model';

@Component({
  selector: 'app-learning-paths-info',
  templateUrl: './learning-paths-info.component.html',
  styleUrls: ['./learning-paths-info.component.scss'],
  standalone: false
})
export class LearningPathsInfoComponent {
  learningPathId: string;
  learningPath: LearningPathFullModel | null = null;
  learningPathCourses: any = [];
  eventsList: any = [];
  filters: any = {
    searchString: '',
  };
  searchString: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public translateService: TranslateService,
    private loaderService: LoadingService,
    private learningPathService: LearningPathService,
  ) {
    this.learningPathId = this.route.snapshot.params['id'];
    this.loadLearningPathData();
  }

  loadLearningPathData(): void {
    const learningPathData = this.loaderService
      .load(
        forkJoin({
          learningPath: this.learningPathService.getLearningPathFull(
            this.learningPathId
          ),
          learningPathCourses: this.learningPathService.getLearningPathCourses(
            this.learningPathId
          ),
        })
      )
      .pipe(shareReplay(1));

    learningPathData.subscribe(({ learningPath, learningPathCourses }) => {
      this.learningPath = learningPath;
      this.learningPathCourses = learningPathCourses;

      this.filterEventsList();
    });
  }

  navigateBack(): void {
    this.router.navigate(['learning-paths']);
  }

  filterEventsList() {
    this.eventsList = [...this.learningPathCourses];

    if (!!this.searchString) {
      this.eventsList = this.eventsList.filter((obj: any) => {
        return (
          obj.name.toLowerCase().includes(this.searchString.toLowerCase()) ||
          (obj.description || '')
            .toLowerCase()
            .includes(this.searchString.toLowerCase())
        );
      });
    }
  }

  onSearchInput(event: any) {
    this.searchString = event.value;
    this.filterEventsList();
  }

  isTrainingLocked(event: any): boolean {
    return event.status === CoursePersonStatusModel.Required;
  }
}
